//----------------------------------------------------------------------------------------------------------------------
// Property Handlers Index
//----------------------------------------------------------------------------------------------------------------------

import type { LevelManager } from '../managers/level.ts';

import { registerColliderHandler } from './collider.ts';
import { registerLodHandler } from './lod.ts';
import { registerOccluderHandler } from './occluder.ts';
import { applyPostProcessing } from './postProcessing.ts';
import { registerSoundHandler } from './sound.ts';
import { registerTriggerHandler } from './trigger.ts';
import { registerVisibleHandler } from './visible.ts';

//----------------------------------------------------------------------------------------------------------------------

export {
    applyPostProcessing,
    registerColliderHandler,
    registerLodHandler,
    registerOccluderHandler,
    registerSoundHandler,
    registerTriggerHandler,
    registerVisibleHandler,
};

//----------------------------------------------------------------------------------------------------------------------

/**
 * Register all built-in property handlers with the given LevelManager.
 * Call this during game initialization to enable default property handling.
 *
 * @param levelManager
 */
export function registerAllPropertyHandlers(levelManager : LevelManager) : void
{
    registerColliderHandler(levelManager);
    registerLodHandler(levelManager);
    registerOccluderHandler(levelManager);
    registerSoundHandler(levelManager);
    registerTriggerHandler(levelManager);
    registerVisibleHandler(levelManager);
}

//----------------------------------------------------------------------------------------------------------------------
